import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLanguageFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 7L9 5H3V3.72C3.6 3.38 4 2.74 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 2.74 0.4 3.38 1 3.72V19H3V15H8L9 17H16V7H10ZM14 15H10L9 13H3V7H8L9 9H14V15Z",
		fill: "#AEAEAE"
	})]
});
const ForwardRef = forwardRef(SvgLanguageFlag);
export { ForwardRef as ReactComponent };
